import { Injectable } from "@angular/core";
import { Http, Headers, URLSearchParams } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";
import { AppService } from "../app.service";

@Injectable()

export class UsersService {

    apiUrl: String;
    jwt: String;
    constructor(private http: Http, private appService: AppService) {
        this.apiUrl = environment.apiUrl;
        this.jwt = appService.getJwt();
    }

    getUsersList(filterParams: any) {
        const url = this.apiUrl + 'api/cms/user/list';
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        const body = JSON.stringify(filterParams);
        return this.http.post(url, body, { headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

    createUser(data: any) {
        const url = this.apiUrl + 'api/cms/user/create';
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        const body = JSON.stringify(data);
        return this.http.post(url, body, { headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

    editUser(data: any) {
        const url = this.apiUrl + 'api/cms/user/edit';
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        const body = JSON.stringify(data);
        return this.http.put(url, body, { headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

    deleteUser(id: string) {
        const url = this.apiUrl + 'api/cms/user/delete/'+ id;
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        return this.http.delete(url, { headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

}


// WEBPACK FOOTER //
// /build/client-cms/src/app/users/users.service.ts